import React from "react";
import { useFormError } from "@magento/peregrine/lib/talons/FormError/useFormError";
import { GenericErrorModal } from "@Components/BookTable/GenericErrorModal";
var FormError = _ref => {
  var {
    classes: propClasses,
    errors,
    id,
    scrollOnError = true
  } = _ref;
  var talonProps = useFormError({
    errors
  });
  var {
    errorMessage
  } = talonProps;
  return errorMessage ? /*#__PURE__*/React.createElement(GenericErrorModal, {
    id: "form-error-".concat(id),
    isOpen: true,
    title: "ERROR",
    info: errorMessage
  }) : null;
};
export default FormError;